// components/Typography/variants.jsx
export default {
// 52px 700
admin_h1: "text-[40px] md:text-[46px] lg:text-[52px] text-admin_text leading-tight font-bold",

// 36px 700
admin_h2: "text-[28px] md:text-[32px] lg:text-[36px] text-admin_text leading-tight font-bold",

// 28px 700,
admin_h3: "text-[22px] md:text-[24px] lg:text-[28px] text-admin_text leading-tight font-bold",

//22 px 700
admin_h4: "text-[18px] lg:text-[22px] text-admin_text leading-tight font-bold",

// 16px 600
admin_label: "text-[16px] text-admin_text leading-normal font-semibold mt-0 mb-2",

// 16px 600
admin_label_dim: "text-[16px] text-admin_text_secondary leading-normal font-semibold mt-0 mb-2",

// 16px 400
admin_body: "text-[16px] text-admin_text leading-normal font-normal",

// 16px 400 gray
admin_body_dim: "text-[16px] text-admin_text_secondary leading-normal font-normal",

// 16px 700
admin_body_accent: "text-[16px] text-admin_text leading-normal font-bold",

// 20px 700, color is defined per case
admin_btn1: "text-[17px] lg:text-[20px] leading-tight font-bold",

// 20px 700
admin_btn2: "text-[17px] lg:text-[22px] leading-tight font-bold",

// 15px 400 text color is defined per case 
admin_txt: "text-[15px] leading-tight font-normal",

// 15px 700 text color is defined per case 
admin_txt_accent: "text-[15px] leading-tight font-bold",

// 15px 400 gray
admin_txt_dim: "text-[15px] text-admin_text_secondary leading-tight font-normal",

// 14px 400 text color is defined per case 
admin_txt1: "text-[14px] leading-tight font-normal",

// 14px 700 text color is defined per case 
admin_txt1_accent: "text-[14px] leading-tight font-bold",

// 14px 400 gray
admin_txt1_dim: "text-[14px] text-admin_text_secondary leading-tight font-normal",

// 12px 400 text color is defined per case 
admin_txt2: "text-[12px] leading-tight font-normal",

// 12px 700 text color is defined per case 
admin_txt2_accent: "text-[12px] leading-tight font-bold",

// 12px 400 text color is defined per case 
admin_txt2_dim: "text-[12px] text-admin_text_secondary leading-tight font-normal",

// 17px 400
admin_menu: "text-[15px] lg:text-[17px] leading-tight font-normal text-admin_text",

// error
admin_error: "text-[14px] text-admin_error leading-tight font-normal",
}
